<template>
  <basic-container>

    <avue-form :option="excelOption" v-model="excelForm" style="height: calc(100vh - 160px);">

      <template slot="excelTemplate">
       <div>
        <el-button type="success" @click="handleTemplate()">
          点击下载<i class="el-icon-download el-icon&#45;&#45;right"></i>
        </el-button>
         <div style="color: #f00">请务必确认填入"上级科室名称"和"部门类型"正确！</div>
       </div>
      </template>
      <template slot="excelTemplate2">
        <div>
        <el-button type="success" @click="handleTemplate2()">
          点击下载<i class="el-icon-download el-icon&#45;&#45;right"></i>
        </el-button>
          <div style="color: #f00">请务必确认填入"部门","岗位"和"角色"正确！</div>
        </div>
      </template>
      <template slot="excelTemplate3">
        <div>
        <el-button type="success" @click="handleTemplate3()">
          点击下载<i class="el-icon-download el-icon&#45;&#45;right"></i>
        </el-button>
          <div style="color: #f00">请务必确认填入"单位"和"耗材类型"已录入项目字典，保证填入正确!</div>
        </div>
      </template>
      <template slot="excelTemplate4">
        <div>
        <el-button type="success" @click="handleTemplate4()">
          点击下载<i class="el-icon-download el-icon&#45;&#45;right"></i>
        </el-button>
          <div style="color: #f00">请务必确认填入"区域编号","区域名称","区域全称","排序"和"节点类型"层级关系正确！</div>
        </div>
      </template>
      <template slot="excelTemplate5">
        <div>
        <el-button type="success" @click="handleTemplate5()">
          点击下载<i class="el-icon-download el-icon&#45;&#45;right"></i>
        </el-button>
          <div style="color: #f00">请务必确认填入"工单类型"和"工单子类型"正确,其中"工单子类型"可不填!</div>
        </div>
      </template>
      <template slot="excelFile1" slot-scope="scope">
        <el-upload
          class="upload-demo"
          ref="upload"
          :limit="1"
          action=""
          :on-preview="handlePreview"
          :on-change="onChange1"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">请上传 .xls,.xlsx 标准格式文件</div>
        </el-upload>
      </template>
      <template slot="excelFile2" slot-scope="scope">
        <el-upload
          class="upload-demo"
          ref="upload"
          :limit="1"
          action=""
          :on-preview="handlePreview"
          :on-change="onChange2"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">请上传 .xls,.xlsx 标准格式文件</div>
        </el-upload>
      </template>
      <template slot="excelFile3" slot-scope="scope">
        <el-upload
          class="upload-demo"
          ref="upload"
          :limit="1"
          action=""
          :on-preview="handlePreview"
          :on-change="onChange3"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">请上传 .xls,.xlsx 标准格式文件</div>
        </el-upload>
      </template>
      <template slot="excelFile4" slot-scope="scope">
        <el-upload
          class="upload-demo"
          ref="upload"
          :limit="1"
          action=""
          :on-preview="handlePreview"
          :on-change="onChange4"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">请上传 .xls,.xlsx 标准格式文件</div>
        </el-upload>
      </template>
      <template slot="excelFile5" slot-scope="scope">
        <el-upload
          class="upload-demo"
          ref="upload"
          :limit="1"
          action=""
          :on-preview="handlePreview"
          :on-change="onChange5"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">请上传 .xls,.xlsx 标准格式文件</div>
        </el-upload>
      </template>
    </avue-form>

  </basic-container>
</template>

<script>
  import {getToken} from '@/util/auth';
  import{uploadExcelFile1,uploadExcelFile2,uploadExcelFile3,uploadExcelFile4,uploadExcelFile5} from '@/api/system/initdata';

  export default {
    name: "inithpss",
    data() {
      return {
        fileList: [],
        excelForm: {},
        excelOption: {
          height: 'auto',
          calcHeight: 90,
          submitBtn: false,
          emptyBtn: false,
          labelWidth: 130,
          group: [
            {
/*              icon: 'el-icon-info',
              label: '基础数据生成',
              collapse: true,
              prop: 'group1',*/
              column: [
                {
                  label: '项目名称',
                  prop: "projectId",
                  type: "tree",
                  span: 8,
                  row:true,
                  labelWidth:80,
                  dicUrl: "/api/v4ward/project/getProjectList",
                  props: { label: "name", value: "id" },
                },
                {
                  label: '部门基础数据模板下载',
                  prop: 'excelTemplate',
                  formslot: true,
                  span: 12,
                  labelWidth:160,
                },
                {
                  label: '部门基础数据生成',
                  prop: 'excelFile1',
                  type: 'upload',
                  formslot: true,
                  action: '/api/baseImport/uploadExcelDept',
                  loadText: '基础数据上传中，请稍等',
                  span: 12,
                  tip: '请上传 .xls,.xlsx 标准格式文件',
                },
                {
                  label: '用户基础数据模板下载',
                  prop: 'excelTemplate2',
                  formslot: true,
                  span: 12,
                  labelWidth:160,
                },
                {
                  label: '用户基础数据生成',
                  prop: 'excelFile2',
                  type: 'upload',
                  formslot: true,
                  action: '/api/baseImport/uploadExcelUser',
                  loadText: '基础数据上传中，请稍等',
                  span: 12,
                  tip: '请上传 .xls,.xlsx 标准格式文件',
                },
                {
                  label: '耗材基础数据模板下载',
                  prop: 'excelTemplate3',
                  formslot: true,
                  span: 12,
                  labelWidth:160,
                },
                {
                  label: '耗材基础数据生成',
                  prop: 'excelFile3',
                  type: 'upload',
                  formslot: true,
                  action: '/api/baseImport/uploadExcel5',
                  loadText: '基础数据上传中，请稍等',
                  span: 12,
                  tip: '请上传 .xls,.xlsx 标准格式文件，文件不要超过2mb',
                },
                {
                  label: '区域基础数据模板下载',
                  prop: 'excelTemplate4',
                  formslot: true,
                  span: 12,
                  labelWidth:160,
                },
                {
                  label: '区域基础数据生成',
                  prop: 'excelFile4',
                  formslot: true,
                  type: 'upload',
                  action: '/api/baseImport/uploadExcel6',
                  loadText: '基础数据上传中，请稍等',
                  span: 12,
                  tip: '请上传 .xls,.xlsx 标准格式文件，文件不要超过2mb',
                },
                {
                  label: '服务项目数据模板下载',
                  prop: 'excelTemplate5',
                  formslot: true,
                  span: 12,
                  labelWidth:160,
                },
                {
                  label: '服务项目数据生成',
                  prop: 'excelFile5',
                  formslot: true,
                  type: 'upload',
                  action: '/api/baseImport/uploadExcel7',
                  loadText: '基础数据上传中，请稍等',
                  span: 12,
                  tip: '请上传 .xls,.xlsx 标准格式文件，文件不要超过2mb',
                },
              ]
            },
           ],
        },
      }
    },
    methods: {

      //部门导入
      onChange1(file, done){
        if (this.vdui.isEmpty(this.excelForm.projectId)) {
          this.$message.error('请选择项目后导入基础数据');
          return;
        }
        console.log('------------------',file)
        const formData = new FormData();
        formData.append('projectId', this.excelForm.projectId);
        formData.append('file', file.raw);
        uploadExcelFile1(formData).then(
          (r) => {
            console.log(r)
            this.$message.success(r.data.msg);
            this.onLoad();
            this.$refs.cutPaymentOffsetFormRef.resetForm();
            this.fileListNum = true;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      },
      //用户导入
      onChange2(file, done){
        if (this.vdui.isEmpty(this.excelForm.projectId)) {
          this.$message.error('请选择项目后导入基础数据');
          return;
        }
        console.log('------------------',file)
        const formData = new FormData();
        formData.append('projectId', this.excelForm.projectId);
        formData.append('file', file.raw);
        uploadExcelFile2(formData).then(
          (r) => {
            console.log(r)
            this.$message.success(r.data.msg);
            this.onLoad();
            this.$refs.cutPaymentOffsetFormRef.resetForm();
            this.fileListNum = true;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      },
      //耗材上传
      onChange3(file, done){
        if (this.vdui.isEmpty(this.excelForm.projectId)) {
          this.$message.error('请选择项目后导入基础数据');
          return;
        }
        console.log('------------------',file)
        const formData = new FormData();
        formData.append('projectId', this.excelForm.projectId);
        formData.append('file', file.raw);
        uploadExcelFile3(formData).then(
          (r) => {
            this.$message.success(r.data.msg);
            this.onLoad();
            this.$refs.cutPaymentOffsetFormRef.resetForm();
            this.fileListNum = true;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      },
      //区域上传
      onChange4(file, done){
        if (this.vdui.isEmpty(this.excelForm.projectId)) {
          this.$message.error('请选择项目后导入基础数据');
          return;
        }
        console.log('------------------',file)
        const formData = new FormData();
        formData.append('projectId', this.excelForm.projectId);
        formData.append('file', file.raw);
        uploadExcelFile4(formData).then(
          (r) => {
            this.$message.success(r.data.msg);
            this.onLoad();
            this.$refs.cutPaymentOffsetFormRef.resetForm();
            this.fileListNum = true;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      },
      //服务项目上传
      onChange5(file, done){
        if (this.vdui.isEmpty(this.excelForm.projectId)) {
          this.$message.error('请选择项目后导入基础数据');
          return;
        }
        console.log('------------------',file)
        const formData = new FormData();
        formData.append('projectId', this.excelForm.projectId);
        formData.append('file', file.raw);
        uploadExcelFile5(formData).then(
          (r) => {
            this.$message.success(r.data.msg);
            this.onLoad();
            this.$refs.cutPaymentOffsetFormRef.resetForm();
            this.fileListNum = true;
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      },


      handleTemplate() {
        window.open(`/api/baseImport/export-templateDept?Blade-Auth=${getToken()}`);
      },
      handleTemplate2() {
        window.open(`/api/baseImport/export-templateUser?Blade-Auth=${getToken()}`);
      },
      handleTemplate3() {
        window.open(`/api/baseImport/export-templateConsumable?Blade-Auth=${getToken()}&projectId=`+ this.excelForm.projectId);
      },
      handleTemplate4() {
        if (!this.excelForm.projectId){
          this.$message.error('请选择项目名称后导出基础数据');
          return;
        }
        window.open(`/api/baseImport/export-templateArea?Blade-Auth=${getToken()}&projectId=`+this.excelForm.projectId);
      },
      handleTemplate5() {
        window.open(`/api/baseImport/export-templateServiceItem?Blade-Auth=${getToken()}&projectId=`+this.excelForm.projectId);
      },

    }
  }
</script>

<style scoped>

</style>

